import type { RouteRecordRaw } from "vue-router";
import type { MjfRouteMeta } from "@shared/types/localTypes/router";
import { RouteNames } from "@shared/types/localTypes/router";
import { ssoLogin, ssoLoginFailed } from "@/router/guard/sso.ts";
import { checkActiveSession } from "@/router/guard/login.ts";

export default {
  path: "/auth",
  name: RouteNames.Auth,
  redirect: { name: RouteNames.Login },
  meta: { isGuest: true } as MjfRouteMeta,
  component: () => import("@/views/login/LoginBase.vue"),
  children: [
    {
      path: "/login",
      name: RouteNames.Login,
      component: () => import("@/views/login/LoginView.vue"),
      beforeEnter: checkActiveSession,
    },
    {
      path: "/sso-login",
      name: RouteNames.SSOLogin,
      beforeEnter: ssoLogin,
      meta: { autoLogout: true } as MjfRouteMeta,
    },
    {
      path: "/sso-login-failed",
      name: RouteNames.SSOLoginFailed,
      beforeEnter: ssoLoginFailed,
      meta: { autoLogout: true } as MjfRouteMeta,
    },
  ],
} as RouteRecordRaw;
